"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _textModule = _interopRequireDefault(require("./text.module.scss"));
var _mediaModule = _interopRequireDefault(require("./media.module.scss"));
var _transitionsModule = _interopRequireDefault(require("./transitions.module.scss"));
var _utilitiesModule = _interopRequireDefault(require("./utilities.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var globalStyles = {
  text: _textModule["default"],
  media: _mediaModule["default"],
  transition: _transitionsModule["default"],
  utility: _utilitiesModule["default"]
};
var CssClassNames = /*#__PURE__*/_createClass(
/**
 * @param {'object {key:string}'} CSSModulesObject - Object resulting from CSS Modules import
 */
function CssClassNames() {
  var _this = this;
  var CSSModulesObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  _classCallCheck(this, CssClassNames);
  _defineProperty(this, "camelize", function (str) {
    return str.replace(/\W+(.)/g, function (match, chr) {
      return chr.toUpperCase();
    });
  });
  _defineProperty(this, "className", function (cssClasses) {
    var additionalClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var keyPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'className';
    var obj = {};
    if (!cssClasses) {
      return obj;
    }
    obj[keyPropName] = _this.getClassName(cssClasses, additionalClasses);
    return obj;
  });
  _defineProperty(this, "getClassName", function (cssClasses) {
    var additionalClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var cls = cssClasses.split(/ |\n|\r/).map(function (key) {
      var style = _this.styleNames[key] || _this.styleNames[_this.camelize(key)];
      return style && typeof style === 'string' ? style : key;
    }).join(' ').trim();
    return additionalClasses ? cls.concat(' ', additionalClasses) : cls;
  });
  _defineProperty(this, "getCssProp", function (props, keyProps) {
    if (typeof keyProps === 'string') {
      keyProps = [keyProps];
    }
    var cssProp = [];
    keyProps.forEach(function (keyProp) {
      switch (_typeof(props[keyProp])) {
        case 'object':
          cssProp.push(Object.keys(props[keyProp] || {}).reduce(function (css, key) {
            return props[keyProp][key] !== 'undefined' && props[keyProp][key] !== '' ? [].concat(_toConsumableArray(css), ["".concat(keyProp, "-").concat(key !== 'xs' ? "".concat(key, "-") : '').concat(props[keyProp][key])]) : css;
          }, []).join(' '));
          break;
        case 'undefined':
          break;
        default:
          cssProp.push("".concat(keyProp, "-").concat(props[keyProp]));
      }
    });
    return cssProp.join(' ');
  });
  var theStyles = {};
  defaults.forEach(function (def) {
    if (globalStyles[def]) {
      theStyles = _objectSpread(_objectSpread({}, theStyles), globalStyles[def]);
    }
  });
  if (_typeof(CSSModulesObject) === 'object') {
    theStyles = _objectSpread(_objectSpread({}, theStyles), CSSModulesObject);
  }
  this.styleNames = theStyles;
});
exports["default"] = CssClassNames;